import { render, staticRenderFns } from "./AfterLogin.vue?vue&type=template&id=634775b4&scoped=true&"
import script from "./AfterLogin.vue?vue&type=script&lang=js&"
export * from "./AfterLogin.vue?vue&type=script&lang=js&"
import style0 from "./AfterLogin.vue?vue&type=style&index=0&id=634775b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634775b4",
  null
  
)

export default component.exports